module.exports = __webpack_public_path__ + "img/logo-educ.542ecf15.png";